/**
 * @class ReadMoreElement
 * @description Add functionalities to "read more" elements. Ticket ID: KAYTCONT-732
 */
class ReadMoreElement {
  /**
   * @constructor
   * @description Find and initialize ReadMoreElements
   * @returns {void}
   */
  constructor() {
    this.elements = document.querySelectorAll('.read-more-element');
    this.headerHeight = document.querySelector('header')?.offsetHeight || 0;
    this.init();
  }

  /**
   * @method attachEvents
   * @description Attach events to elements
   * @returns {void}
   */
  attachEvents() {
    this.elements.forEach((element) => {
      const button = element.querySelector('.read-more-element__button');

      button.addEventListener('click', () => {
        element.classList.toggle('read-more-element--open');

        // if user closed the element, scroll window to the top of the element
        if (!element.classList.contains('read-more-element--open')) {
          const rect = element.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const top = rect.top + scrollTop - (this.headerHeight + 100);
          window.scrollTo({
            top,
            behavior: 'instant',
          });
        }
      });
    });
  }

  /**
   * @method init
   * @description Initialize ReadMoreElement
   * @returns {void}
   */
  init() {
    if (!this.elements.length) return;
    this.attachEvents();
  }
}

export default ReadMoreElement;
